<div *ngIf="data" class="close">
    <mat-icon (click)="close()">close</mat-icon>
</div>
<h3 *ngIf="data" class="row col-sm-12 warning">
{{ data.message }}<br />
</h3>

<form [formGroup]="form" (submit)="onSubmit($event)">
<mat-progress-bar *ngIf="progress" mode="indeterminate"></mat-progress-bar>
<div class="row" style="margin-top: 10px">
    <mat-checkbox color="primary" formControlName="acceptTerm" required>
      Aceito os termos de uso da plataforma
      <a [attr.href]="LinkTermos" target="_blank">(ler termo de uso)</a>
    </mat-checkbox>
  </div>
  <div class="row">
    <mat-error *ngIf="!form.get('acceptTerm').value">
      É necessário aceitar os termos de uso
    </mat-error>
  </div>
  <div class="row">
    <mat-checkbox color="primary" formControlName="acceptContract" required>
      Aceito o contrato da plataforma
      <a [attr.href]="LinkContrato" target="_blank">(ler contrato)</a>
    </mat-checkbox>
  </div>
  <div class="row">
    <mat-error *ngIf="!form.get('acceptContract').value">
      É necessário aceitar o contrato
    </mat-error>
  </div>

  <div class="actions">
    <button
      mat-raised-button
      class="custom-primary"
      color="primary"
      type="submit"
      [disabled]="!form.valid"
    >
      Salvar
    </button>
  </div>
 
</form>

<iframe
  *ngIf="mauticFormSrc"
  [src]="mauticFormSrc"
  hidden
  frameborder="0"
></iframe>